import ApiService from '@/data/services/ApiService'
import { IPaginationQueryParams } from '@/data/models/Pagination'
import { AxiosResponse } from 'axios'
import { IPaginatedServiceResponse, IServiceResponse } from '@/data/models/ServiceResponse'

export interface IParentGetPaginatedQuery extends IPaginationQueryParams {
  teamId?: number;
}

export class ParentApiService extends ApiService {
  /**
   * Returns paginated list of Parents
   *
   * @param query
   */
  static async getPaginated(query: object): Promise<IPaginatedServiceResponse<object>> {
    return this.axios.get('parents', { params: query })
      .then((response: AxiosResponse<IPaginatedServiceResponse<object>>) => response.data)
  }

  static async getAll(query: object): Promise<IPaginatedServiceResponse<object>> {
    return this.axios.get('parents', { params: query })
      .then((response: AxiosResponse<IPaginatedServiceResponse<object>>) => response.data)
  }

  /**
   * Given parent's id, fetches parent data from database
   *
   * @param id
   */
  static async getParentDetails(id: string): Promise<IServiceResponse<object>> {
    return this.axios.get(`parents/${id}`)
      .then((response: AxiosResponse) => response.data)
  }

  /**
   * Given data, creates new entry in database
   *
   * @param parentFormData
   */
  static async create(parentFormData: object): Promise<IServiceResponse<object>> {
    return this.axios.post('parents', parentFormData)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  /**
   * Given data, updates parent's entry in database
   *
   * @param parentId
   * @param data
   */
  static async update(parentId: string, data: object): Promise<IServiceResponse<object>> {
    return this.axios.put(`parents/${parentId}`, data)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  /**
   * Given parent's id, deletes event in database
   *
   * @param parentId
   */
  static async delete(parentId: string): Promise<AxiosResponse> {
    return this.axios.delete(`parents/${parentId}`)
  }
}
